<template>
  <div>
    <div class="flex items-center">
      <div class="flex-1 pr-4" style="min-width: 100px">
        <p>Rooms</p>
      </div>
      <div class="flex-none">
        <numeral-stepper-new v-model="rooms" />
      </div>
    </div>
  </div>
</template>

<script>
import NumeralStepperNew from '../NumeralStepperNew'

export default {
  components: {
    NumeralStepperNew
  },
  props: ['value'],
  data () {
    return {
      rooms: this.value
    }
  },
  watch: {
    rooms () {
      this.$emit('input', this.rooms)
    }
  }
}
</script>